import { useFormik } from 'formik';
import { ChangeEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import useCloneGroups from '../../../../API/hooks/groups/useCloneGroups';
import { CloneGroupsRequest } from '../../../../API/types/Groups';
import Input from '../../../../components/common/Input/Input';
import { Button } from '../../../../components/ui/Button/Button';
import CheckBox from '../../../../components/common/CheckBox/CheckBox';
import S from './CloneGroupStyles';

type Props = {
  fleetId: string;
  groupIds: string[];
  toggleModal: (closed: boolean) => void;
  onSuccess?: () => void;
};

function CloneGroup({
  fleetId, groupIds, toggleModal, onSuccess,
}: Props): JSX.Element {
  const [submitError, setSubmitError] = useState<string | string[] | null>(null);
  const onSubmitFail = (errorMessage: string): void => setSubmitError(errorMessage);
  const onSubmitSuccess = (): void => {
    toast.success('Groups has been cloned successfully');
    toggleModal(false);
    if (onSuccess) onSuccess();
  };

  const { mutate: cloneGroups } = useCloneGroups(
    onSubmitSuccess,
    onSubmitFail,
  );

  const formik = useFormik({
    initialValues: {
      mergeUsers: false,
    },
    onSubmit: (values) => cloneGroups({
      ...values,
      groupIds,
      fleetId,
    } as unknown as CloneGroupsRequest),
    // validate: (values) => {
    //   const errors = {} as Record<string, string | undefined>;

    //   return errors;
    // },
    // validateOnMount: true,
  });

  // if there is onSubmit error formik will stack in submitting state
  // blocking further interactions with submit button
  useEffect(() => {
    formik.setSubmitting(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitError]);

  const handleInputChange = (e: ChangeEvent<any>): void => {
    formik.handleChange(e);
    setSubmitError('');
  };

  const handleCheckboxChange = (id: string, state: boolean): void => {
    formik.setFieldValue(id, state);
    formik.setSubmitting(false);
    setSubmitError('');
  };

  return (
    <S.Wrapper>
      <form onSubmit={formik.handleSubmit}>
        <div className="details-container">
          <S.RowContainer>
            All selected groups will be cloned.
          </S.RowContainer>
          <CheckBox
            label="Copy existing user"
            name="mergeUsers"
            state={formik.values.mergeUsers}
            onChange={handleCheckboxChange}
          />
          <S.RowContainer className="buttons-container">
            <Button
              height="50px"
              onClick={() => toggleModal(false)}
              type="button"
            >
              Cancel
            </Button>
            <Button
              className="add-button"
              height="50px"
              type="submit"
              disabled={formik.isSubmitting || !formik.isValid || !!submitError}
            >
              Clone
            </Button>
          </S.RowContainer>
          {!!submitError && (
            typeof submitError === 'string'
              ? <S.ErrorMessage>{submitError}</S.ErrorMessage>
              : submitError.map((error) => <S.ErrorMessage>{error}</S.ErrorMessage>)
          )}
        </div>
      </form>
    </S.Wrapper>
  );
}

export default CloneGroup;
